import CentumButton from 'components/MainPage/dcs/centumvp/components/Button/CentumButton';
import CentumInput from 'components/MainPage/dcs/centumvp/components/Input/CentumInput';
import CentumSelect from 'components/MainPage/dcs/centumvp/components/Select/CentumSelect';
import React, { useState } from 'react';
import { tabComponents } from '../SearchCondition';
import { Config, OccurrenceParams } from '../searchConditionInterface';

interface FieldProps {
    label: string | undefined;
    property: 'stationName' | 'hierarchyName' | 'tagName' | 'batchID' | undefined;
    params: any[] | undefined;
    displayEnabled: boolean;
    enable?: boolean;
    propertyEnable?: boolean;
    type?: 'checkbox' | 'button' | 'text' | 'radio' | undefined;
    hasButton?: boolean;
    options?: string[];
    SetOccurrenceSource: (
        property: 'stationName' | 'hierarchyName' | 'tagName' | 'batchID',
        params: 'active' | 'params',
        index: number,
        value: any
    ) => void;
}

function OccurrenceSourceComponent(props: tabComponents) {
    // const blockOpt = ['1', '2', '3', '4'];
    const blockOpt = [''];

    const opccurrenceSource = props.tempConfig.opccurrenceSource;
    const displayEnabled = props.tempConfig.display.search;

    const SelectType = (mode: string) => {
        const updateConf = { ...props.tempConfig };
        updateConf.opccurrenceSource.select(mode);
        props.SaveConfig(updateConf);
    };

    const SetOccurrenceSource = (
        property: 'stationName' | 'hierarchyName' | 'tagName' | 'batchID',
        params: 'active' | 'params',
        index: number,
        value: any
    ) => {
        const updateConf = { ...props.tempConfig };
        updateConf.opccurrenceSource.setOccurrenceSource(property, params, index, value);
        props.SaveConfig(updateConf);
    };

    function capitalizeFirstLetter(string: string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const inputs = Object.entries(props.tempConfig.opccurrenceSource.specifyOccurrenceSource)
        .map(([key, value]) => {
            if (typeof value === 'object' && !Array.isArray(value) && value !== null && key !== 'state') {
                if (!(key as 'stationName' | 'hierarchyName' | 'tagName' | 'batchID').includes(key)) {
                    throw new Error(`Invalid property key: ${key}`);
                }

                const label =
                    capitalizeFirstLetter(key)
                        .match(/[A-Z][a-z]+/g)
                        ?.join(' ') || '';

                let Field: FieldProps = {
                    enable: opccurrenceSource.specifyOccurrenceSource.state,
                    property: key as 'stationName' | 'hierarchyName' | 'tagName' | 'batchID',
                    params: value.params,
                    SetOccurrenceSource: SetOccurrenceSource,
                    label: label,
                    displayEnabled: displayEnabled
                };

                switch (key) {
                    case 'tagName':
                        Field.propertyEnable = opccurrenceSource.specifyOccurrenceSource.tagName.active;
                        return Field;
                    case 'batchID':
                        Field.propertyEnable = opccurrenceSource.specifyOccurrenceSource.batchID.active;
                        return Field;
                    case 'hierarchyName':
                        Field.propertyEnable = opccurrenceSource.specifyOccurrenceSource.hierarchyName.active;
                        Field.hasButton = true;
                        return Field;
                    case 'stationName':
                        Field.propertyEnable = opccurrenceSource.specifyOccurrenceSource.stationName.active;
                        // Field.options = blockOpt;
                        return Field;
                    default:
                        return null;
                }
            }
            return null;
        })
        .filter(Boolean);

    // console.log(inputs);

    return (
        <div
            style={{
                boxSizing: 'border-box',
                width: '100%',
                padding: '20px',
                fontSize: '12px',
                color: displayEnabled ? 'black' : '#808080',
                pointerEvents: displayEnabled ? 'auto' : 'none'
            }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <CentumInput
                    enable={!displayEnabled}
                    checked={opccurrenceSource.all}
                    type="radio"
                    id="All"
                    onChange={() => SelectType('all')}
                />
                <span>All</span>
            </div>
            <div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <CentumInput
                        enable={!displayEnabled}
                        checked={opccurrenceSource.specifyOccurrenceSource.state}
                        type="radio"
                        id="SpecifyOccurrenceSource"
                        onChange={() => SelectType('specifyOccurrenceSource')}
                    />
                    <span>Specify Occurrence Source</span>
                </div>
                <div style={{ padding: '5px 10px' }}>
                    {inputs.map((config, index) => (
                        <Field
                            key={index}
                            displayEnabled={displayEnabled}
                            propertyEnable={config?.propertyEnable}
                            params={config?.params}
                            SetOccurrenceSource={SetOccurrenceSource}
                            label={config?.label}
                            property={config?.property}
                            {...config}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default OccurrenceSourceComponent;

function Field(props: FieldProps) {
    const {
        label = '',
        params,
        displayEnabled,
        enable = false,
        propertyEnable = false,
        type = 'checkbox',
        property = 'stationName',
        hasButton = false,
        options,
        SetOccurrenceSource
    } = props;

    return (
        <div>
            <CentumInput
                enable={enable && displayEnabled}
                checked={propertyEnable}
                id={label}
                type={type}
                onChange={(id: any, value: any) => SetOccurrenceSource(property, 'active', 0, value)}
            />
            <span>{label}</span>
            <div style={{ display: 'flex', padding: '0px 10px' }}>
                {Array.isArray(params) &&
                    params.map((num, index) => (
                        <div key={`${label}-${index}`} style={{ display: 'flex', padding: '2px 10px' }}>
                            {options ? (
                                <CentumSelect
                                    disabled={!enable || !displayEnabled}
                                    value={num || ''}
                                    options={options}
                                    onChange={(value: string | number) =>
                                        SetOccurrenceSource(property, 'params', index, value)
                                    }
                                    width={120}
                                    height={20}
                                />
                            ) : (
                                <>
                                    <CentumInput
                                        enable={enable && displayEnabled}
                                        id={`${label}-${index}`}
                                        value={num || ''}
                                        type="text"
                                        width={hasButton ? 100 : 120}
                                        height={20}
                                        onChange={(id: any, value: any) =>
                                            SetOccurrenceSource(property, 'params', index, value)
                                        }
                                    />
                                    {hasButton && (
                                        <CentumButton
                                            key={`${label}-${index}`}
                                            disabled={!enable || !displayEnabled}
                                            name={'...'}
                                            onClick={() => {}}
                                            style={{ height: '20px', width: '20px', padding: '1px' }}
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    ))}
            </div>
        </div>
    );
}
